export type PMOHistoryEntry = {
  ts: string;
  user?: string;
  kind: 'task_progress' | 'task_meta' | 'quarter_meta';
  quarter: string;
  axeId?: string;
  taskIdx?: number;
  label: string;
  from: string;
  to: string;
};

export type PMOState = {
  progress: Record<string, number>;
  quarters: Record<string, { theme?: string; totalHeures?: number; synthese?: string[] }>;
  tasks: Record<string, Record<string, any>>;
  history: PMOHistoryEntry[];
};

const API_BASE_URL = '/api/prisme/roadmap/pmo';

export async function getRoadmapPmoState(): Promise<PMOState> {
  const res = await fetch(API_BASE_URL, { credentials: 'include' });
  if (!res.ok) throw new Error('Erreur chargement Roadmap PMO');
  return await res.json();
}

export async function saveRoadmapPmoState(state: Omit<PMOState, 'history'>): Promise<PMOState> {
  const res = await fetch(API_BASE_URL, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(state),
  });
  if (!res.ok) throw new Error('Erreur sauvegarde Roadmap PMO');
  return await res.json();
}

